import React from "react";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";

export default function Privacy() {
    return (
        <div data-testid="privacy-page">
            <SEO
                title="Privacy — Moving Mountains Advisors"
                description="We do not sell your data. Read what Moving Mountains collects, why, and how we use it."
            />
            <PageHeader
                eyebrow="Legal"
                title="Privacy Policy."
                subtitle="Straightforward. No buried surprises."
            />
            <section className="mm-section bg-white">
                <div className="mm-container max-w-3xl space-y-6 text-mm-ink leading-relaxed">
                    <h2 className="mm-display text-2xl text-mm-navy">
                        We do not sell your data.
                    </h2>
                    <p>
                        Moving Mountains Inc. does not sell, rent, or share personal
                        information with third-party data brokers. Information you
                        share with us is used solely to match you with a licensed
                        advisor and — if you choose to move forward — to submit an
                        application on your behalf to an insurance carrier you
                        approve.
                    </p>
                    <h3 className="mm-display text-xl text-mm-navy">
                        What we collect
                    </h3>
                    <p>
                        Contact details you provide (name, email, phone), basic
                        demographic details relevant to underwriting (date of birth,
                        sex, tobacco use, coverage status, product interest, budget,
                        timeline), and chat transcripts with our AI concierge,
                        Jarvis.
                    </p>
                    <h3 className="mm-display text-xl text-mm-navy">How we use it</h3>
                    <p>
                        To contact you about your inquiry, match you with a licensed
                        Moving Mountains advisor, and — only with your consent —
                        submit a formal application to a carrier. This experience is
                        powered by advanced AI technology; transcripts may be
                        reviewed by staff to improve our service.
                    </p>
                    <h3 className="mm-display text-xl text-mm-navy">Your choices</h3>
                    <p>
                        You may request a copy of your data, correct it, or request
                        deletion at any time by emailing us. Unsubscribing from
                        emails does not affect active policies.
                    </p>
                    <h3 className="mm-display text-xl text-mm-navy">Contact</h3>
                    <p>
                        Privacy questions:{" "}
                        <a className="mm-link" href="mailto:Brent@MovingMountainsAdvisors.com">
                            Brent@MovingMountainsAdvisors.com
                        </a>
                        .
                    </p>
                </div>
            </section>
        </div>
    );
}
